export let FabricChannel = /*#__PURE__*/function (FabricChannel) {
  FabricChannel["atlaskit"] = "atlaskit";
  FabricChannel["elements"] = "fabric-elements";
  FabricChannel["navigation"] = "navigation";
  FabricChannel["editor"] = "editor";
  FabricChannel["media"] = "media";
  FabricChannel["peopleTeams"] = "peopleTeams";
  FabricChannel["notifications"] = "notifications";
  FabricChannel["recentWork"] = "recentWork";
  FabricChannel["atlas"] = "atlas";
  FabricChannel["crossFlow"] = "crossFlow";
  FabricChannel["linkingPlatform"] = "linkingPlatform";
  FabricChannel["postOffice"] = "postOffice";
  FabricChannel["aiMate"] = "aiMate";
  FabricChannel["avp"] = "avp";
  return FabricChannel;
}({});